
// Base.
import { Prop, Mixins } from 'vue-property-decorator'
import Component from 'vue-class-component'
import usersMixins from './UsersMixin'
import BlueButton from '../Atomic/BlueButton.vue'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'

// Used Models.
import { User } from '../../models/user'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import ToolTipButton from '@/components/Atomic/ToolTipButton.vue'

@Component({
  components: {
    ToolTipButton,
    BlueButton,
    GreenButton,
    RedButton,
    CardTitle,
  },
})
export default class ResetPassword extends Mixins(usersMixins) {
  @Prop(Function) public readonly resetUsersPassword!: (
    data: User[],
    sameYear: boolean,
  ) => User[]
  @Prop() private readonly getJsonData!: User[]
  @Prop() private readonly disabled!: boolean
  @Prop() private readonly sameYear!: boolean

  constructor() {
    super()
  }

  public mounted() {
    this.initialize()
  }

  private async save() {
    this.isPending = true
    this.resetUsersPassword(this.getJsonData, this.sameYear)
    this.isPending = false
    this.dialog = false
  }

  private initialize() {
    // TODO
  }
}
